import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import { FilterLayer } from '../Layers/FilterLayer';
import type { FilterLayerOptions } from '../Layers/Layers.types';

// This filter removes all layers so that it's possible to "filter in" markers instead of filtering them out
export const removeAllFilter = function (layers: ClusteredMarkerLayer[], options?: FilterLayerOptions): FilterLayer {
    const defaultOptions: FilterLayerOptions = {
        filterFn: () => {
            return [];
        },
    };

    return new FilterLayer('remove-all-filter', layers, { ...defaultOptions, ...options });
};
